export default [
  {
    path: '/info-company',
    component: () => import('./views/Index'),
    name: 'info-company',
    redirect: { name: 'info-company-list' },
    children: [
      {
        path: '',
        name: 'info-company-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'auth',
        },
      },
    ],
  },
]
